import React, { useCallback, useContext, useEffect, useState } from "react"
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { Icone } from "../Icones/Index"
import { Modal } from "../Modal/modal"
import { Link } from "react-router-dom"
import { LoginContext } from "../../Contexts/login-context"
import { useDispatch, useSelector } from "react-redux"
import { changeDark, changeHash, changeName, selectUser } from "../Redux/userSlice"
import { FaAngleDown, FaUser } from "react-icons/fa"
import { ImExit } from "react-icons/im"
import Breadcrumbs from "../../Components/bread/breadcrumbs"
import { UserService } from "../../Pages/Users/User.service"
import Menu from "../Menu/Menu"
import { Api } from "../../Utils/api"
import { Funcoes } from "../../Utils/Funcoes"

export type TemplateProps = {
    children: JSX.Element
    isLoading?: boolean
}

export const Template = ({ children, isLoading }: TemplateProps) => {

    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    const { logo } = useContext(LoginContext)
    let user: any = useSelector(state => selectUser(state))
    let newName = user.name

    const dadosEmpresa = Funcoes.GetDadosEmpresa()

    if (newName) {
        newName = newName.split(' ')[0]
    }

    useEffect(() => {
        let hash = localStorage.getItem('@ecommerce/hash')
        let name = localStorage.getItem('@ecommerce/name')
        dispatch(changeHash(hash))
        dispatch(changeName(name))

        let darkLight = localStorage.getItem('@ecommerce/tema') || 'light'
        let divHTML_APP = document.getElementById('html_app') as HTMLElement

        if (darkLight === "dark") {

            if (divHTML_APP) {

                divHTML_APP.classList.add('dark')
                dispatch(changeDark('dark'))

            }

        } else {

            if (divHTML_APP) {

                divHTML_APP.classList.remove('dark')
                dispatch(changeDark('light'))

            }

        }

        //getConfig()

    }, [])

    const handleModalConfirmClick = async () => {
        LogOut()
    }

    const LogOut = async () => {

        setLoading(true)
        const resp = await Api('auth/logOut', 'put')
        setLoading(false)

        if (resp.data) {

            if (resp.data.error === "0") {

                /*
                let modal = document.getElementById('modal')
                let modalContent = document.getElementById('modal-content')

                if (modal) {
                    modal.style.visibility = 'hidden'


                    if (modalContent) {
                        modalContent.classList.add('mt-[-400px]')
                        modalContent.classList.remove('mt-24')
                    }
                }
                */

                localStorage.removeItem('@ecommerce/hash')
                localStorage.removeItem('@ecommerce/name')
                localStorage.removeItem('@ecommerce/tema')
                localStorage.removeItem('@ecommerce/cor_tema')
                localStorage.removeItem('@ecommerce/cor_bg_menu')
                localStorage.removeItem('@ecommerce/cor_bg_nav')
                localStorage.removeItem('@ecommerce/cor_barra')
                localStorage.removeItem('@ecommerce/dados_empresa')
                localStorage.removeItem('imageLogo')

                localStorage.removeItem('@ecommerce/desc_sub_variacao')
                localStorage.removeItem('@ecommerce/desc_variacao')
                localStorage.removeItem('@ecommerce/idVariacao')
                window.location.href = '/'
                //window.location.href = '/landingPage'
            }
        }
    }

    const handleMenuClick = () => {
        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            if (divPerfil.classList.contains('hidden')) {
                divPerfil.classList.remove('hidden')
            } else {
                divPerfil.classList.add('hidden')
            }
        }

    }

    const getConfig = async () => {

        const attr = await UserService.FindConfig()

        localStorage.setItem('@ecommerce/idVariacao', attr.data.config.id?.toString())
        localStorage.setItem('@ecommerce/desc_variacao', attr.data.config.desc_variacao)
        localStorage.setItem('@ecommerce/desc_sub_variacao', attr.data.config.desc_sub_variacao)

    }

    const toggleMenu = () => {

        let divMenu = document.getElementById('menu-lateral') as HTMLDivElement
        let divConteudo = document.getElementById('div-body') as HTMLDivElement
        let divFiltro = document.getElementById('div-filtro') as HTMLDivElement
        let divInputPesq = document.getElementById('div-inputPesquisa') as HTMLDivElement

        let divButtonMenu = document.getElementById('divButtonMenu') as HTMLDivElement

        let divPerfilButton = document.getElementById('divPerfilButton') as HTMLDivElement

        let divTituloTemplate = document.getElementById('tituloTemplate') as HTMLDivElement

        if (divMenu) {

            if (divMenu.classList.contains('ml-[-230px]')) { // Oculto

                divMenu.classList.remove('ml-[-230px]')
                divMenu.classList.remove('lg:ml-4')
                divMenu.classList.add('lg:ml-[-230px]')

                divConteudo.classList.remove('lg:pl-8')
                divConteudo.classList.remove('lg:ml-[230px]')

                if (divButtonMenu.classList.contains("pl-0")) {
                    divButtonMenu.classList.add("pl-[220px]")
                    divButtonMenu.classList.add("pr-10")
                    divButtonMenu.classList.remove("pl-0")
                }

                divTituloTemplate.classList.remove('md:block')
                divTituloTemplate.classList.add('md:hidden')

                //   divMenu.classList.remove('max-sm:ml-[-300px]')
                //   divMenu.classList.remove('md:ml-4')
                //   divMenu.classList.add('md:ml-[-230px]')
                //   divConteudo.classList.remove('max-sm:ml-0')
                //   divConteudo.classList.add('pl-4')
                //   divConteudo.classList.remove('md:ml-[230px]')
                //   divFiltro.classList.add('md:flex-col')
                //   divFiltro.classList.add('lg:grid')
                //   divFiltro.classList.add('lg:grid-cols-2')
                //   divFiltro.classList.add('lg:gap-1')
                //   divFiltro.classList.add('xl:grid-cols-5')
                //   divInputPesq.classList.add('col-span-2')
                //   divInputPesq.classList.add('xl:col-span-1')

            } else { // Menu aberto


                divMenu.classList.add('ml-[-230px]')
                divMenu.classList.add('lg:ml-4')
                divMenu.classList.remove('lg:ml-[-230px]')

                divConteudo.classList.add('lg:pl-8')
                divConteudo.classList.add('lg:ml-[230px]')

                if (divButtonMenu.classList.contains("pl-[220px]")) {
                    divButtonMenu.classList.add("pl-0")
                    divButtonMenu.classList.remove("pl-[220px]")
                    divButtonMenu.classList.remove("pr-10")
                }

                divTituloTemplate.classList.add('md:block')
                divTituloTemplate.classList.remove('md:hidden')


                //  divConteudo.classList.add('max-sm:ml-0')
                //  divMenu.classList.add('md:ml-4')
                //  divMenu.classList.remove('md:ml-[-230px]')
                //  divConteudo.classList.remove('pl-4')
                //  divConteudo.classList.add('md:ml-[230px]')
                //  divMenu.classList.add('max-sm:ml-[-300px]')
                //  divFiltro.classList.remove('md:flex-col')
                //  divFiltro.classList.remove('lg:flex-col')
                //  divFiltro.classList.add('md:flex-row')
                //  divFiltro.classList.remove('lg:grid')
                //  divFiltro.classList.remove('lg:grid-cols-2')
                //  divFiltro.classList.remove('lg:gap-2')
                //  divInputPesq.classList.remove('col-span-2')
            }
        }
    }

    const handleSairClick = () => {

        let modal = document.getElementById('modal')
        let modalContent = document.getElementById('modal-content')

        if (modal) {
            modal.style.visibility = 'visible'

            if (modalContent) {
                modalContent.classList.remove('mt-[-400px]')
                modalContent.classList.add('mt-24')
            }
        }

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }

    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }
    }, [])

    /* esse codigo estava dando erro 
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Adiciona um ouvinte de redimensionamento para atualizar a largura da tela
        window.addEventListener('resize', handleResize);

        // Remove o ouvinte de redimensionamento ao desmontar o componente
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    */

    /*
    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            // Prevenir a ação padrão do Enter
            e.preventDefault();
        }
    };

    onKeyDown={handleKeyDown}  // link id="tituloTemplate"
    onKeyDown={handleKeyDown}  // link bt perfil
    */

    return (

        <div className={`h-lvh`}>

            <Menu />

            <div className={`flex w-full h-16 items-center bg-slate-200 dark:bg-slate-700 fixed z-30 duration-500`}>

                <div id="divButtonMenu" className={`fixed left-2 flex items-center w-auto h-16 pl-0 lg:pl-0 lg:pr-0 transition-all duration-500`}>

                    <button tabIndex={-1} onClick={toggleMenu} className={`flex items-center justify-center w-8 h-8 ml-2 text-black dark:text-white outline-none transition-colors duration-150`}>
                        <Icone icon={faBars} size="lg" />
                    </button>
                    <Link tabIndex={-1} id='tituloTemplate' onMouseUp={handleMouseUp} to="/" className={`text-sm text-black dark:text-white w-full ml-2 max-w-[155px] hidden md:block lg:block transition-colors duration-150`}>{dadosEmpresa?.fantasia || dadosEmpresa?.razao}</Link>

                </div>

                <div id="bread" className={`w-auto hidden md:block max-w-2xl ml-[60px] fixed left-[220px]`}>
                    <Breadcrumbs />
                </div>

                <div className={`flex justify-end w-full h-full mr-[5px] flex-grow-1`}>

                    <div className={`flex flex-col justify-center items-center w-auto h-full`}>

                        <div id="divPerfilButton" onClick={handleMenuClick} className={`flex items-center pr-2 md:justify-center md:pl-0 h-[70%] w-auto hover:cursor-pointer`}>

                            <div className={`flex -space-x-1 overflow-hidden`}>

                                <img className={`flex justify-center items-center w-10 h-10 ring-2 ring-slate-200 dark:ring-slate-700 rounded-full duration-500`} src='https://img.freepik.com/vetores-premium/icone-de-perfil-de-avatar_188544-4755.jpg?w=826' alt="" />

                            </div>

                            <span className={`text-black dark:text-white text-sm ml-2 hidden md:block transition-colors duration-150`}>{newName}</span>
                            <span className={`ml-1 text-black dark:text-white hidden md:block transition-colors duration-150`}><FaAngleDown className={`h-4 w-4`} /></span>
                        </div>

                        <div id="div-perfil" className={`w-auto sm:w-[150px] h-auto absolute mt-[135px] right-5 rounded-md bg-white dark:bg-slate-500 shadow-lg ring-1 ring-black dark:ring-slate-700 ring-opacity-5 focus:outline-none hidden z-50`}>

                            <div className={`py-1 hover:bg-slate-200 dark:hover:bg-slate-600 hover:rounded-t-md`}>
                                <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/profile" className={`w-full flex justify-start items-center text-slate-700 dark:text-slate-100 px-4 py-2 text-sm`}>
                                    <FaUser className={`mx-2`} />
                                    <span className={`hidden sm:block`}>Perfil</span>
                                </Link>
                            </div>

                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-400`} />

                            <div id="menu-sair" className={`py-1 hover:bg-slate-200 dark:hover:bg-slate-600 hover:rounded-b-md`}>
                                <button tabIndex={-1} className={`w-full flex justify-start items-center text-slate-700 dark:text-slate-100 px-4 py-2 text-sm`} onClick={handleSairClick}>
                                    <ImExit className={`mx-2`} />
                                    <span className={`hidden sm:block`}>Sair</span>
                                </button>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            {isLoading &&
                <div className={`fixed inset-0 flex justify-center items-center bg-black/50 z-50`}>
                    <div className={`inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                    </div>
                </div>
            }

            {children}
            <Modal loading={loading} titulo="Fechar sistema" caption="Deseja sair do sistema e retornar para a tela de login?" buttonConfirmClick={handleModalConfirmClick} />

        </div>

    )

}